/**
 * Application Constants
 *
 * Centralized configuration for application-wide constants.
 */

/**
 * External Links
 */
export const BACK_TO_WEBSITE_LINK = 'https://vibemarketing.diy';

/**
 * Subscription Plans
 */
export const SUBSCRIPTION_PLANS = {
  STARTER: 'starter',
  GROWTH: 'growth',
  PRO: 'pro',
} as const;

/**
 * Pricing
 */
export const PLAN_PRICING = {
  [SUBSCRIPTION_PLANS.STARTER]: 299,
  [SUBSCRIPTION_PLANS.GROWTH]: 999,
  [SUBSCRIPTION_PLANS.PRO]: 1299,
} as const;
